import FailureProcessingConfig from "./FailureProcessingConfig";
import FailureProcessingOverview from "./FailureProcessingOverview";
import streamFailureColumn from "./streamFailureColumn";
export default {
  systemConfigurations: [
    {
      component: FailureProcessingConfig,
      displayName: "Failure Processing",
      configType: "org.graylog.plugins.failure.config.EnterpriseFailureHandlingConfiguration",
      permissions: "indices:failures"
    }
  ],
  systemOverview: [
    {
      component: FailureProcessingOverview
    }
  ],
  "components.streams.overview.tableElements": [streamFailureColumn]
};
